import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import { MasterAreaPickingRBAC, MasterAreaPickingUpsertRBAC } from './rbac'

const MasterAreaPickingList = lazy(() => import('../pages/MasterAreaPickingList'))
const MasterAreaPickingUpsert = lazy(() => import('../pages/MasterAreaPickingUpsert'))

export const MasterAreaPickingListRouter: RouterFeatureInterface<
  'MasterAreaPickingListRouter',
  '/dashboard/outbound/master-area-picking'
> = {
  name: 'MasterAreaPickingListRouter',
  Component: MasterAreaPickingList,
  path: '/dashboard/outbound/master-area-picking',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: MasterAreaPickingRBAC.pageID,
  isDashboard: true,
}

export const MasterAreaPickingCreateRouter: RouterFeatureInterface<
  'MasterAreaPickingCreateRouter',
  '/dashboard/outbound/master-area-picking/create'
> = {
  name: 'MasterAreaPickingCreateRouter',
  Component: MasterAreaPickingUpsert,
  path: '/dashboard/outbound/master-area-picking/create',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: MasterAreaPickingUpsertRBAC.pageID,
  isDashboard: true,
}

export const MasterAreaPickingEditRouter: RouterFeatureInterface<
  'MasterAreaPickingEditRouter',
  '/dashboard/outbound/master-area-picking/edit/:id'
> = {
  name: 'MasterAreaPickingEditRouter',
  Component: MasterAreaPickingUpsert,
  path: '/dashboard/outbound/master-area-picking/edit/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: MasterAreaPickingUpsertRBAC.pageID,
  isDashboard: true,
}

const MasterAreaPickingRouter = [
  MasterAreaPickingListRouter,
  MasterAreaPickingCreateRouter,
  MasterAreaPickingEditRouter,
]

export const MasterAreaPickingRouterDetail = generateRouterDetail(MasterAreaPickingRouter)

export default MasterAreaPickingRouter
